import "../utils/KeyboardEventsUtil";
import { ResolutionHandler } from "../utils/ResolutionHandler";
import { CustomEvents } from '../utils/CustomEvents';
import { on, emit, off, one } from '../utils/EventsBus';
import { detect } from "detect-browser";
import "jquery-jcreate";
import { HideLoader } from '../utils/Loader';
import AnimateComponent from "../components/AnimateComponent";

export default class Controller {
  constructor() {
    this.loadedComponents = [];
    this.$customEvents = CustomEvents;
    this.$on = on;
    this.$emit = emit;
    this.$off = off;
    this.$one = one;
  }

  /**
   * Components that will be always initialized in every controller
   * @returns {string[]}
   * @constructor
   **/
  static get BASE_COMPONENTS() {
    return [
      'HeaderComponent',
      'CollapseComponent',
      'SearchLayerComponent',
      'CartLayerComponent',
      'SimpleCarouselComponent',
      'VideoBrightcoveComponent',
      'CommunicationPopupComponent',
      'NewsletterPopupComponent',
      'LoginComponent',
      'LoginPopupComponent',
      'FidelityPopupComponent',
      'RecommendationEngineComponent',
      'TrackingComponent',
      'DataShowComponent',
      'MiniCartComponent',
      'ShowPasswordComponent',
      'ModalComponent',
      'ChatComponent',
      'InputComponent',
      'SelectComponent',
      'VerifaliaInputComponent',
      'DateInputComponent',
      'MyAccountLayerComponent',
      'StylistPickCarouselComponent',
      'ProductCardComponent',
      'CountryItemComponent',
      'CountriesSectionComponent',
      'NewsletterComponent',
    ];
  }

  static get ALLOW_MULTIPLE_LOAD_COMPONENTS() {
    return [
      'CollapseComponent',
      'SizeSelectorComponent',
      'VideoBrightcoveComponent',
      'CustomSelectComponent',
      'NotifyMeComponent',
      'FidelityRewardComponent',
      'InputComponent',
      'SelectComponent',
      'VerifaliaInputComponent',
      'DateInputComponent',
      'NewsletterComponent',
      'LoginComponent',
      'LoginPopupComponent',
      'FidelityPopupComponent',
      'SimpleCarouselComponent',
      'CountdownComponent',
      'ShopCategoryComponent',
      'PriceRangeComponent',
      'ProductCardComponent',
      'CountryItemComponent',
      'CountriesSectionComponent',
      'CarouselModuleComponent',
      'SizeTableComponent',
      'WishlistCardComponent',
      'ListingShortcutsComponent',
      'ShortcutPromoComponent',
    ];
  }

  setBrowserAttributes(obj) {
    return new Promise((resolve, reject) => {
      try {
        for (let key of Object.keys(obj)) {
          document.documentElement.setAttribute(
            `data-browser-${key}`,
            obj[key]
          );
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = "") {
    if (logStr != "") {
      let myName = this.constructor.name;
      console.debug(`[${myName}] ${logStr}`);
    }
  }

  /*
   *  Initialization logic of the page
   */
  init() {
    this.log("Initializing..");

    if (detect())
      this.setBrowserAttributes(detect()).then(res => {
        console.debug("Browser data saved");
      });

    ResolutionHandler();

    try {
      let componentsToRender = [];
      // Dynamic init of components related to a controller
      componentsToRender = [
        ...Controller.BASE_COMPONENTS,
        ...this.constructor.COMPONENTS
      ];
      this.log(`Rendering: ${componentsToRender}`);
      for (let component of componentsToRender) {
        this.instanceComponent(component);
      }
      // example of hiding loader, here so it works in every page, put it where needed
      HideLoader();
      // Common component for components' animations when they appear in view
      let animateComponent = new AnimateComponent();
      animateComponent.render();
    } catch (error) {
      console.error(
        "Failed to iterate over controller's components",
        error.stack
      );
    }
    //
    this.loadDynamicComponents();

  }

  loadDynamicComponents() {
    // Dynamic init of components to be loaded
    let $this = this;
    // observer listener
    function listener(records) {
      let nodesToList = [];
      records.forEach(function (record) {
        var list = record.addedNodes;
        var i = list.length - 1;
        for ( ; i > -1; i-- ) {
          // if i find a new component
          if ( typeof list[i] == 'object' && list[i].nodeType == '1') {
            if (list[i].getAttribute('data-js-component') != null ) {
              nodesToList.push(list[i]);
            } else {
              let variabiledarinominare  =  Array.prototype.slice.call(list[i].querySelectorAll("[data-js-component]"));
              nodesToList = variabiledarinominare;
            }
          }
        }
      });
      // loop the nodes
      this.exit = false;
      nodesToList.forEach(node => {
        // taking the mutation
        let componentDiv = node;
        let componentToRender = componentDiv.getAttribute("data-js-component");
        if (componentToRender == null || componentToRender == "") return false;
        //
        if ($this.loadedComponents.indexOf([componentToRender]) === -1 && !this.exit) {
          $this.instanceComponent(componentToRender);
          // this.exit = true;
        } else if ( !this.exit ) {
          let newComp = new [componentToRender](event.currentTarget);
          // render new component
          newComp.render();
        }
      });
    }
    // define observer
    let observer = new MutationObserver(listener);
    // nodes to observe
    let targetNodes = document.querySelectorAll('.general-component');
    if ( typeof targetNodes != 'undefined' && targetNodes != null ) {
      // loop to observe each node
      targetNodes.forEach( target => {
        observer.observe(target, { childList: true, subtree: true });
      });
    }

    let sizeNode = document.querySelector('#editorial-content');
    if ( typeof sizeNode != 'undefined' && sizeNode != null ) {
      // loop to observe each node
        observer.observe(sizeNode, { childList: true, subtree: true });
    }
  }

  instanceComponent(ComponentName) {
    let selector = `[data-js-component="${ComponentName}"]`;
    if (document.querySelector(selector)) {
      let componentElements = document.querySelectorAll(selector);
      componentElements.forEach(element => {
        // check if contains the loaded class
        if (!element.classList.contains('component-loaded')) {
          // i add the class
          element.classList.add('component-loaded');
          this.importComponents(ComponentName)
            .then(({ default: ComponentName }) => {
              // i don't want to load multiple times a component, but with some exceptions
              // COMPONENTNAME must be added to component for that, thanks to yarn build and minification
              if (!this.loadedComponents.includes(ComponentName) || ( typeof ComponentName.prototype.COMPONENTNAME != 'undefined' && Controller.ALLOW_MULTIPLE_LOAD_COMPONENTS.includes(ComponentName.prototype.COMPONENTNAME) )  )  {
                let component = new ComponentName(element);
                component.render();
                this.loadedComponents.push(ComponentName);
              }
            })
            .catch(error => {
              console.error("Failed to load the component", error.stack);
            });
        }
      });
    }
  }


  /* --------------------------------------------------------------------- */
  /* this method import a module and returns the import promise            */
  /* with this method we centralize the dynamic import                     */
  /* --------------------------------------------------------------------- */
  importComponents(componentName) {
    return import(/* webpackChunkName:`component-[request]` */ `../components/${componentName}`);
  }
}
